import SettingsPageLayout from './PageLayout';
import SettingsPageProvider from './PageProvider';

const Settings = () => (
    <SettingsPageProvider>
        <SettingsPageLayout />
    </SettingsPageProvider>
);

export default Settings;
